import React, { useCallback, useRef, useState } from "react";
import Webcam from "react-webcam";
import { Button } from "semantic-ui-react";
import usePhoto from "../hooks/usePhoto";

export default function CameraWrapper() {
  const { toggleCamera, onSavePhoto } = usePhoto();
  const webcamRef = useRef(null);
  const [isFacingUser, setIsFacingUser] = useState(true);

  const capture = useCallback(() => {
    const imageSrc = webcamRef.current.getScreenshot();
    if (imageSrc) onSavePhoto(imageSrc);
  }, [webcamRef, onSavePhoto]);

  const videoConstraints = {
    facingMode: isFacingUser ? "user" : "environment",
  };

  return (
    <div className="video-container">
      <Webcam
        className="video"
        ref={webcamRef}
        audio={false}
        screenshotFormat="image/jpeg"
        videoConstraints={videoConstraints}
      />
      <div className="mt-1 control">
        <Button
          color="red"
          icon="arrow left"
          circular
          size="huge"
          onClick={() => toggleCamera(false)}
        />
        <Button
          positive
          circular
          size="huge"
          icon="camera"
          type="button"
          onClick={capture}
        />
        <Button
          icon="refresh"
          secondary
          onClick={() => setIsFacingUser(!isFacingUser)}
          circular
          type="button"
          size="huge"
        />
      </div>
    </div>
  );
}
